import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ProfileTab } from "@/components/settings/AccountTabs";
import { BrokerTab } from "@/components/settings/BrokerTab";

export default function Settings() {
  return (
    <div className="space-y-5" data-testid="settings-page">
      <h1 className="font-display text-3xl font-bold tracking-tight text-slate-100">Settings</h1>
      <Tabs defaultValue="account">
        <TabsList className="flex-wrap border border-slate-800 bg-slate-900">
          <TabsTrigger value="account" data-testid="settings-tab-account">Account</TabsTrigger>
          <TabsTrigger value="broker" data-testid="settings-tab-broker">MT5 account</TabsTrigger>
        </TabsList>
        <TabsContent value="account" className="mt-5"><ProfileTab /></TabsContent>
        <TabsContent value="broker" className="mt-5"><BrokerTab /></TabsContent>
      </Tabs>
    </div>
  );
}
